export const SIZES = {
	mini: "2rem",
	small: "2.2rem",
	medium: "2.6rem",
};
